import request, { unwrapResult } from 'lib/request';
import { ApiError } from 'types';

export const fetcher = <T, B = any, E extends ApiError = ApiError>(endpoint: string) =>
  request<T, B, E>(endpoint).then((result) => unwrapResult(result).payload);
